import React, { memo } from "react";
import VisibleHook from "../../../../tool/visibleHook";
import styles from "./index.module.scss";
import { classNames, calcNumZodiac, calculateSpecialCodeAnimal } from "../../../../tool";
import NumberCount from "../../../../components/number";
import dayjs from "dayjs";

const History = (props) => {
  const { visible, handleHide, historyIssue, dicInfo, onShowVideo } = props;
  const { containerVisible, contentVisible } = VisibleHook({ visible });
  return (
    <div
      className={classNames(
        styles.container,
        containerVisible ? styles.showMask : ""
      )}
      onClick={handleHide}
    >
      <div
        className={classNames(
          styles.content,
          (visible ? contentVisible : visible) ? styles.show : ""
        )}
      >
        <div
          className={classNames(
            styles.innerContent,
            (visible ? contentVisible : visible) ? styles.show : ""
          )}
        >
          <div className={styles.list}>
            {historyIssue
              .filter((i) => i.lotteryResult)
              .map((item, index) => {
                const { rowId, lotteryResult, etime, ctime } = item;
                const resultArr = JSON.parse(JSON.stringify(lotteryResult));
                resultArr.splice(resultArr.length - 1, 0, "+");
                const arrDesc = [
                  calculateSpecialCodeAnimal(resultArr[0],etime), // 第一位生肖
                  calculateSpecialCodeAnimal(resultArr[1],etime),
                  calculateSpecialCodeAnimal(resultArr[2],etime),
                  calculateSpecialCodeAnimal(resultArr[3],etime),
                  calculateSpecialCodeAnimal(resultArr[4],etime),
                  calculateSpecialCodeAnimal(resultArr[5],etime),
                  "",
                  calculateSpecialCodeAnimal(resultArr[7],etime),
                ];

                return (
                  <div className={styles.item} key={index}>
                    <div className={styles.issueInfo}>
                      <div className={styles.issue}>
                        第{rowId}期 开奖结果
                        <div
                          className={styles.liveVideo}
                          onClick={() => {
                            if (dicInfo.hisVideoUrl) {
                              onShowVideo(
                                `${dicInfo.hisVideoUrl}/${rowId}.mp4`
                              );
                              // window.open(
                              //   `${dicInfo.hisVideoUrl}/${rowId}.mp4`,
                              //   "__blank"
                              // );
                            }
                          }}
                        >
                          <img
                            src={require("../../../../assets/imgs/new/iconReplay.png")}
                          />
                        </div>
                      </div>
                      <div className={styles.time}>
                        {dayjs(etime).format("YYYY/MM/DD")}
                      </div>
                    </div>
                    <div className={styles.result}>
                      <div className={styles.number}>
                        {resultArr.map((item, index) => {
                          return item === "+" ? (
                            <div className={styles.resultPlus} key={index}>
                              +
                            </div>
                          ) : (
                            <NumberCount
                              width={"9.156rem"}
                              height={"9.156rem"}
                              fontSize={"4.267rem"}
                              className={styles.resultNumber}
                              number={item}
                              key={index}
                            />
                          );
                        })}
                      </div>
                      <div className={styles.desc}>
                        {arrDesc.map((item, index) => {
                          return index === 6 ? (
                            <div
                              className={styles.resultPlus}
                              key={index}
                            ></div>
                          ) : (
                            <div className={styles.resDesc} key={index}>
                              {item}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default memo(History, (prev, next) => {
  return JSON.stringify(prev) === JSON.stringify(next);
});
